import { useEffect, useRef } from 'react';
import { useAppStore } from '../stores/useAppStore';
import { businessInfoAPI } from '../api';
import { rememberShop } from '../utils/shopIdentity';

/**
 * Custom hook to load and manage business information
 * Loads business info on mount and caches it in Zustand store
 */
export const useBusinessInfo = () => {
  const { businessInfo, setBusinessInfo } = useAppStore();
  const loadCount = useRef(0);

  useEffect(() => {
    const loadBusinessInfo = async () => {
      // Only load once - if loadCount is 1 or more, don't call API
      if (loadCount.current >= 1) {
        return;
      }

      try {
        // Only load if we don't have business info yet
        if (loadCount.current === 0) {
          loadCount.current = 1; // Mark as loaded
          const response = await businessInfoAPI.getPublic();
          setBusinessInfo(response.data);
          rememberShop(response.data); // lets the next visit's sign-in page name this shop at once
        }
      } catch (error) {
        console.error('Failed to load business information:', error);
        // Keep default values if loading fails
      }
    };

    loadBusinessInfo();
  }, [businessInfo, setBusinessInfo]); // Proper dependency array

  return {
    businessInfo,
    setBusinessInfo
  };
};
